import { Routes } from 'components/routing/Routes';
import { TopLevelLoader } from 'components/TopLevelLoader';
import React, { Suspense } from 'react';
import { ApiExplorerProvider } from 'wrappers/ApiExplorerProvider';
import { AuthProvider } from 'wrappers/AuthProvider';
import { DeviceSizeProvider } from 'wrappers/DeviceSizeProvider';
import { FeatureGateProvider } from 'wrappers/FeatureGateProvider';
import { GlobalApiAccessTokenProvider } from 'wrappers/GlobalApiAccessTokenProvider';
import { GlobalErrorBoundary } from 'wrappers/GlobalErrorBoundary';
import { IdleTimerContainer } from 'wrappers/IdleTimerContainer/IdleTimerContainer';
import { PaymentsApiAuthProvider } from 'wrappers/PaymentsApiAuthProvider';
import { PodApiAccessTokenProvider } from 'wrappers/PodApiAccessTokenProvider';
import { UrqlProvider } from 'wrappers/urqlProvider/UrqlProvider';
import { UserInfoProvider } from 'wrappers/UserInfoProvider';
import { WorkspacePermissionProvider } from 'wrappers/WorkspacePermissionProvider/WorkspacePermissionProvider';
import { WorkspaceProvider } from 'wrappers/WorkspaceProvider';

import { ColorModeProvider } from '@fragment/ui/src/components/ColorMode/ColorModeProvider';

import { ToastProvider } from './wrappers/ToastProvider';

export const App = () => (
  <FeatureGateProvider>
    <GlobalErrorBoundary>
      <AuthProvider>
        <ColorModeProvider>
          <Suspense fallback={<TopLevelLoader />}>
            <GlobalApiAccessTokenProvider>
              <UrqlProvider>
                <UserInfoProvider>
                  <WorkspaceProvider>
                    <WorkspacePermissionProvider>
                      <PodApiAccessTokenProvider>
                        <PaymentsApiAuthProvider>
                          <IdleTimerContainer>
                            <Suspense fallback={<TopLevelLoader />}>
                              <ApiExplorerProvider>
                                <ToastProvider>
                                  <DeviceSizeProvider>
                                    <Routes />
                                  </DeviceSizeProvider>
                                </ToastProvider>
                              </ApiExplorerProvider>
                            </Suspense>
                          </IdleTimerContainer>
                        </PaymentsApiAuthProvider>
                      </PodApiAccessTokenProvider>
                    </WorkspacePermissionProvider>
                  </WorkspaceProvider>
                </UserInfoProvider>
              </UrqlProvider>
            </GlobalApiAccessTokenProvider>
          </Suspense>
        </ColorModeProvider>
      </AuthProvider>
    </GlobalErrorBoundary>
  </FeatureGateProvider>
);
